export interface AchievementItem {
  id: string;
  name: string;
  category: string;
  year: string;
  status: string;
  detail: AchievementDetail;
}

export interface AchievementDetail {
  homepage: {
    summary: string;
    metrics: { label: string; value: string }[];
    images: string[];
    videoPoster: string;
    videoUrl: string;
  };
  planning: {
    content: string;
  };
  introduction: {
    content: string;
  };
  application: {
    subItems: {
      id: string;
      title: string;
      type: string;
      url: string;
      children?: { name: string; type: string; url: string }[];
    }[];
  };
  supportingMaterials: {
    groups: {
      id: string;
      groupName: string;
      items: { name: string; type: string; url: string }[];
    }[];
  };
  report: {
    subItems: {
      id: string;
      title: string;
      type: string;
      url: string;
    }[];
  };
}

export const achievements: AchievementItem[] = [
  {
    id: "001",
    name: "学科赋能、需求牵引、交叉融合 轨道交通特色土建类一流专业建设探索与实践",
    category: "教学成果",
    year: "2026",
    status: "已公示",
    detail: {
      homepage: {
        summary: `<p style="text-indent:2em;text-align:justify;margin-bottom:0.8em;font-size:18px">根据《华东交通大学党委关于深入推进解放思想、深化改革、开放办学、加快发展的若干意见》（华交党发〔2013〕56号）要求，学校以培养轨道交通特色"下得去、吃得苦、留得住、干得好、上得来"的"五得"高素质复合型人才为目标，通过"学科赋能、需求牵引、交叉融合"等系列举措，探索出了轨道交通特色土建类一流专业建设新模式。</p>
<p style="text-indent:2em;text-align:justify;font-size:18px">经13年探索实践，6个专业入选国家一流本科专业建设点，5个通过工程教育认证。已建成国家级教学实验示范中心等国家级平台4个；建成全国高校黄大年式教师团队等国家级教研团队2个，国家级一流课程16门。近五年，获"挑战杯"学术科技作品竞赛国家级特等奖2项，中国国际大学生创新大赛（原"互联网+"）国家级金奖5项，获詹天佑优秀班集体等集体荣誉4项，获茅以升铁道希望之星等个人荣誉29项；培养学生获国家铁路局等大型央企高度认可，获中国教育报等多家国家媒体报道。</p>`,
        metrics: [
          { label: "成果类型", value: "教学成果" },
          { label: "负责人", value: "张明远 教授" },
          { label: "完成单位", value: "华东交通大学教务处" },
          { label: "参与人员", value: "张明远、李建华、王思源、陈志强、刘芳等12人" },
          { label: "完成时间", value: "2026年6月" },
          { label: "获奖情况", value: "国家级教学成果二等奖" },
        ],
        images: [
          "https://readdy.ai/api/search-image?query=Modern%20Chinese%20high%20speed%20train%20Fuxing%20Hao%20bullet%20train%20speeding%20on%20elevated%20railway%20bridge%20with%20golden%20sunset%20sky%2C%20dramatic%20lighting%2C%20cinematic%20wide%20angle%20shot%2C%20sleek%20white%20train%20with%20red%20stripe%2C%20powerful%20motion%20blur%20on%20tracks%2C%20grand%20epic%20atmosphere%2C%20professional%20photography%2C%20ultra%20detailed&width=900&height=520&seq=achieve-001-hero&orientation=landscape",
          "https://readdy.ai/api/search-image?query=University%20engineering%20students%20and%20professors%20collaborating%20in%20modern%20railway%20laboratory%20with%20train%20model%20and%20digital%20screens%2C%20bright%20clean%20academic%20setting%2C%20warm%20natural%20lighting%2C%20professional%20editorial%20photography%2C%20teamwork%20atmosphere%2C%20clean%20white%20background&width=900&height=520&seq=achieve-001-lab&orientation=landscape",
          "https://readdy.ai/api/search-image?query=Chinese%20university%20students%20in%20safety%20vests%20and%20helmets%20doing%20hands%20on%20railway%20engineering%20practical%20training%20at%20outdoor%20track%20facility%2C%20bright%20sunlight%2C%20industrial%20setting%20with%20rails%20and%20signals%2C%20professional%20documentary%20photography%20style%2C%20clean%20simple%20background%20with%20blue%20sky%2C%20educational%20atmosphere&width=900&height=520&seq=achieve-001-training&orientation=landscape",
          "https://readdy.ai/api/search-image?query=Prestigious%20Chinese%20academic%20award%20ceremony%20with%20red%20backdrop%20and%20gold%20text%20banner%2C%20professor%20receiving%20certificate%20on%20stage%2C%20university%20auditorium%20setting%2C%20warm%20professional%20lighting%2C%20dignified%20scholarly%20atmosphere%2C%20clean%20elegant%20composition%2C%20documentary%20style%20photography&width=900&height=520&seq=achieve-001-award&orientation=landscape",
          "https://readdy.ai/api/search-image?query=Modern%20Chinese%20university%20campus%20building%20with%20contemporary%20architecture%20featuring%20railway%20themed%20design%20elements%2C%20red%20brick%20facade%20with%20glass%20windows%2C%20green%20trees%20and%20landscaping%2C%20bright%20daytime%20scene%2C%20clean%20sky%20background%2C%20architectural%20photography%20style%2C%20grand%20and%20scholarly%20atmosphere&width=900&height=520&seq=achieve-001-campus&orientation=landscape",
        ],
        videoPoster: "https://readdy.ai/api/search-image?query=Chinese%20railway%20civil%20engineering%20education%20documentary%20thumbnail%20style%2C%20modern%20university%20classroom%20with%20railway%20track%20models%20and%20engineering%20blueprints%20on%20display%2C%20warm%20professional%20lighting%2C%20academic%20atmosphere%2C%20high%20speed%20train%20model%20on%20desk%2C%20clean%20scholarly%20setting%2C%20cinematic%20composition%2C%20soft%20depth%20of%20field&width=800&height=450&seq=achieve-video-poster&orientation=landscape",
        videoUrl: "/achievement-video.mp4",
      },
      planning: {
        content: `<h3>一、建设背景与意义</h3><p>随着我国轨道交通事业的快速发展，行业对高素质应用型人才的需求日益迫切。传统的工科人才培养模式在产教融合深度、实践能力培养、校企协同机制等方面存在明显不足，亟需改革创新。</p><h3>二、建设目标</h3><p>以服务轨道交通行业高质量发展为导向，构建产教深度融合的人才培养体系，培养具有扎实理论基础、突出实践能力和创新精神的高素质应用型人才。</p><h3>三、建设思路与原则</h3><p>坚持'需求导向、校企协同、工学结合、持续改进'的建设原则，以产业需求为引领，以校企合作为平台，以项目驱动为手段，全面推进人才培养模式改革。</p><h3>四、实施路径与阶段安排</h3><p>第一阶段（2020-2021）：顶层设计与试点探索，完成人才培养方案修订，建立首批校企合作基地。第二阶段（2022-2023）：全面推广与机制完善，扩大校企合作覆盖面，建成产教融合实训中心。第三阶段（2024-2025）：深化提升与成果凝练，形成可复制推广的人才培养模式。</p><h3>五、保障措施</h3><p>建立校院两级产教融合工作领导小组，设立专项建设经费，完善教师到企业实践锻炼制度，健全教学质量监控与评价体系。</p><h3>六、预期成效</h3><p>建成国内一流的轨道交通人才培养高地，形成具有示范引领作用的产教融合人才培养模式，为行业输送大批高素质应用型人才。</p>`,
      },
      introduction: {
        content: `<h3>一、成果基本情况</h3><p>本成果是华东交通大学在轨道交通人才培养领域的一项系统性改革成果，历时六年，覆盖全校6个轨道交通相关专业，涉及在校学生8000余人。</p><h3>二、解决的主要问题</h3><p>（1）人才培养与产业需求脱节问题；（2）实践教学资源不足、能力培养弱化问题；（3）校企合作机制不健全、合作深度不够问题；（4）教师工程实践能力不足问题。</p><h3>三、主要创新点</h3><p>（1）首创'三段递进式'实践教学体系；（2）构建'校中厂、厂中校'的校企深度融合模式；（3）建立基于行业标准的课程体系和评价机制；（4）形成'双师双能型'教师队伍建设长效机制。</p><h3>四、应用推广情况</h3><p>成果已在华东交通大学6个轨道交通类专业全面实施，并被南昌大学、长沙理工大学、兰州交通大学等8所高校借鉴应用，受益学生超过20000人。</p><h3>五、取得的成效</h3><p>学生实践能力和创新能力显著提升，在各类学科竞赛中获得国家级奖项56项，省级奖项182项。毕业生就业质量持续提高，用人单位满意度达94.7%。</p>`,
      },
      application: {
        subItems: [
          {
            id: "app-01",
            title: "申报书封面及基本信息",
            type: "pdf",
            url: "#",
          },
          {
            id: "app-02",
            title: "申报书正文（第一章~第五章）",
            type: "pdf",
            url: "#",
            children: [
              { name: "第一章 成果背景与意义", type: "pdf", url: "#" },
              { name: "第二章 成果主要内容", type: "pdf", url: "#" },
              { name: "第三章 成果创新点", type: "pdf", url: "#" },
              { name: "第四章 成果应用效果", type: "pdf", url: "#" },
              { name: "第五章 成果推广价值", type: "pdf", url: "#" },
            ],
          },
          {
            id: "app-03",
            title: "申报书附件汇总表",
            type: "pdf",
            url: "#",
          },
          {
            id: "app-04",
            title: "申报书佐证材料目录",
            type: "pdf",
            url: "#",
          },
        ],
      },
      supportingMaterials: {
        groups: [
          {
            id: "mat-00",
            groupName: "成果曾获奖励",
            items: [{ name: "成果曾获奖励", type: "pdf", url: "/1.pdf" }],
          },
          {
            id: "mat-01",
            groupName: "专业所获荣誉",
            items: [{ name: "专业所获荣誉", type: "pdf", url: "/2.pdf" }],
          },
          {
            id: "mat-02",
            groupName: "课程建设",
            items: [{ name: "课程建设", type: "pdf", url: "/3.pdf" }],
          },
          {
            id: "mat-03",
            groupName: "教材建设",
            items: [{ name: "教材建设", type: "pdf", url: "/4.pdf" }],
          },
          {
            id: "mat-04",
            groupName: "平台建设",
            items: [{ name: "平台建设", type: "pdf", url: "/5.pdf" }],
          },
          {
            id: "mat-05",
            groupName: "师资队伍建设",
            items: [{ name: "师资队伍建设", type: "pdf", url: "/6.pdf" }],
          },
          {
            id: "mat-06",
            groupName: "党建思政建设",
            items: [{ name: "党建思政建设", type: "pdf", url: "/7.pdf" }],
          },
          {
            id: "mat-07",
            groupName: "代表性教改项目",
            items: [{ name: "代表性教改项目", type: "pdf", url: "/8.pdf" }],
          },
          {
            id: "mat-08",
            groupName: "产教合作基地",
            items: [{ name: "产教合作基地", type: "pdf", url: "/9.pdf" }],
          },
          {
            id: "mat-09",
            groupName: "国际化人才培养",
            items: [{ name: "国际化人才培养", type: "pdf", url: "/10.pdf" }],
          },
          {
            id: "mat-10",
            groupName: "卓越人才培养",
            items: [{ name: "卓越人才培养", type: "pdf", url: "/11.pdf" }],
          },
          {
            id: "mat-11",
            groupName: "学生学科竞赛获奖",
            items: [{ name: "学生学科竞赛获奖", type: "pdf", url: "/12.pdf" }],
          },
          {
            id: "mat-12",
            groupName: "学生创新创业项目",
            items: [{ name: "学生创新创业项目", type: "pdf", url: "/13.pdf" }],
          },
          {
            id: "mat-13",
            groupName: "优秀毕业生典型",
            items: [{ name: "优秀毕业生典型", type: "pdf", url: "/14.pdf" }],
          },
          {
            id: "mat-14",
            groupName: "企业评价",
            items: [{ name: "企业评价", type: "pdf", url: "/15.pdf" }],
          },
          {
            id: "mat-15",
            groupName: "高校评价",
            items: [{ name: "高校评价", type: "pdf", url: "/16.pdf" }],
          },
          {
            id: "mat-16",
            groupName: "社会影响",
            items: [{ name: "社会影响", type: "pdf", url: "/17.pdf" }],
          },
        ],
      },
      report: {
        subItems: [
          {
            id: "rep-01",
            title: "成果背景及问题提出",
            type: "pdf",
            url: "#",
          },
          {
            id: "rep-02",
            title: "专业建设历程",
            type: "pdf",
            url: "#",
          },
          {
            id: "rep-03",
            title: "解决问题的总体思路",
            type: "pdf",
            url: "#",
          },
          {
            id: "rep-04",
            title: "成果主要内容与解决方法",
            type: "pdf",
            url: "#",
          },
          {
            id: "rep-05",
            title: "主要创新点",
            type: "pdf",
            url: "#",
          },
          {
            id: "rep-06",
            title: "推广应用效果与反思",
            type: "pdf",
            url: "#",
          },
        ],
      },
    },
  },
];